import { render, staticRenderFns } from "./ThePixel.vue?vue&type=template&id=68cfd383"
import script from "./ThePixel.vue?vue&type=script&lang=js"
export * from "./ThePixel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports